'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/throttleTime';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {gpsSupported} from '../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {firebaseAuthSuccess, requestLogout} from '../../auth/actions';
import * as trackLocationActions from '../../settings/actions/trackLocationActions';
import {getCachedPayload, isTracking} from '../../settings/reducers';
import {reduxList} from '../redux/activeTimers';
import {ACTIVE_TIMERS_LIST_NAME} from '../redux/state';
import {getActiveTimers} from '../reducers/state';
import {pauseTimer, startTimer, stopTimer, updateTimerGps} from '../actions';
import {hasGpsItems} from '../reducers/activeTimersReducers';
import {logger} from './logger';

export const epics = [
  onInit,
  onStartTimer,
  onStopTimer,
];

export function onInit(action$) {
  return Observable.merge(
    action$.ofType(firebaseAuthSuccess.TYPE)
      .map(action => action.payload.userId)
      .filter(userId => !!userId)
      .mapTo(reduxList.actions.initList()),
    action$.ofType(requestLogout.TYPE)
      .mapTo(reduxList.actions.destroyList()),
  )
    .catch(epicErrorHandler(logger, 'onInit'));
}

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @return {Observable<ReduxAction>}
 */
export function onStartTimer(action$, store) {
  return action$.ofType(startTimer.TYPE)
    .map(() => {
      if (!gpsSupported()) {
        return void 0;
      } else {
        const rootState = store.getState();
        const cachedPayload = getCachedPayload(rootState);

        if (!isTracking(rootState, ACTIVE_TIMERS_LIST_NAME)) {
          return trackLocationActions.registerTracking({key: ACTIVE_TIMERS_LIST_NAME});
        } else if (cachedPayload) {
          return updateTimerGps(cachedPayload);
        }
      }

      return void 0;
    })
    .filter(Boolean)
    .catch(epicErrorHandler(logger, 'onStartTimer'));
}

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @return {Observable<ReduxAction>}
 */
export function onStopTimer(action$, store) {
  return action$.ofType(stopTimer.TYPE, pauseTimer.TYPE, reduxList.actions.syncListSuccess.TYPE)
    .filter(() => {
      const rootState = store.getState();
      return isTracking(rootState, ACTIVE_TIMERS_LIST_NAME) && !hasGpsItems(getActiveTimers(rootState));
    })
    .mapTo(trackLocationActions.deregisterTracking({key: ACTIVE_TIMERS_LIST_NAME}))
    .catch(epicErrorHandler(logger, 'onStartTimer'));
}



// WEBPACK FOOTER //
// ./src/js/timers/epics/onStartTimer.js